import type { Task } from "../types";

/**
 * Put a task the user just created into the loaded board list.
 * A live refresh can already hold that row. Adding it again shows two cards
 * with the same key. An unloaded list stays unloaded.
 */
export function placeCreatedTask(
  prev: Task[] | undefined,
  task: Task,
): Task[] | undefined {
  if (!prev) return prev;
  const index = prev.findIndex((item) => item.id === task.id);
  if (index === -1) return [...prev, task];
  const next = prev.slice();
  next[index] = task;
  return next;
}

/**
 * Show a step that just became its own task.
 * The step leaves its parent, and the new task is stored once, even when a
 * live refresh already inserted that task.
 */
export function placeConvertedTask(
  prev: Task[] | undefined,
  parentId: string,
  subtaskId: string,
  task: Task,
): Task[] {
  const withoutNew = (prev ?? []).filter((item) => item.id !== task.id);
  const next = withoutNew.map((item) =>
    item.id === parentId
      ? {
          ...item,
          subtasks: item.subtasks?.filter((step) => step.id !== subtaskId),
        }
      : item,
  );
  next.push(task);
  next.sort((a, b) => a.order_position - b.order_position);
  return next;
}
